export default {
	name: 'RoleCategories',
	options: {
		schema: 'users',
		table: 'v_role_categories',
		sortfield: 'category'
	}
};